// TransactionList.jsx
import React from 'react';
import TransactionTable from '../TransactionTable';
import TabSwitcher from '../TabSwitcher';
import TablePaginators from 'components/Pagination/TablePaginator';
import { useDossierRole } from 'contexts/DossierRoleContext';
import { FiArchive } from 'react-icons/fi';
import { FaRegTrashAlt } from 'react-icons/fa';

const TransactionList = ({
  combinedData,
  paginationIndex,
  setPaginationIndex,
  dataLength,
  pageSize,
  setPageSize,
  onActionSelected,
  selectedRows,
  handleRowSelect,
  onEyeClick,
  onDeleteClick,
  onBulkArchive,
  onBulkDelete,
  currentTab,
  setCurrentTab,
  handleFormDepense,
  handleFormVente,
  handleFormCreances,
  handleFormDettes,
  ajoutFou,
  viewArchived,
  allData, // Received from parent
  filters, // Received from parent
  onFilterChange, // Received from parent
  isMobile,
}) => {
  const { canEdit } = useDossierRole();
  return (
  <>
    <div className="HolderButtons">
      <div className="transaction-tabs-scroll">
        <TabSwitcher onTabChange={setCurrentTab} />
      </div>
      {canEdit && !isMobile && currentTab === 'out' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormDepense}
        >
          <span>+ Ajouter une sortie</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'in' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormVente}
        >
          <span>+ Ajouter une entrée</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'creances' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormCreances}
        >
          <span>+ Paiement du Client</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'dettes' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormDettes}
        >
          <span>+ Paiement au Fournisseur</span>
        </button>
      )}
    </div>

    {canEdit && !isMobile && selectedRows?.length > 0 && (
      <div
        className="d-flex align-items-center gap-3 px-3 py-2 mb-2"
        style={{
          background: '#f0fdfa',
          border: '1px solid #99f6e4',
          borderRadius: '12px',
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 600, color: '#0f766e' }}>
          {selectedRows.length} sélectionnée(s)
        </span>
        <button
          type="button"
          className="btn btn-sm"
          style={{
            background: '#009688',
            color: '#fff',
            borderRadius: '20px',
            padding: '4px 14px',
            fontSize: 13,
          }}
          onClick={onBulkArchive}
        >
          <FiArchive style={{ marginRight: 4 }} />
          {viewArchived ? 'Désarchiver' : 'Archiver'}
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          style={{ borderRadius: '20px', padding: '4px 14px', fontSize: 13 }}
          onClick={onBulkDelete}
        >
          <FaRegTrashAlt style={{ marginRight: 4 }} /> Supprimer
        </button>
      </div>
    )}

    {canEdit && isMobile && (
      <div className="transaction-mobile-actions" aria-label="Actions rapides transactions">
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormVente}>
          + Entrée
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormDepense}>
          + Sortie
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormCreances}>
          + Paiement Client
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormDettes}>
          + Paiement Fournisseur
        </button>
      </div>
    )}

    <TransactionTable
      data={combinedData || []} // Always render table, even if empty
      allData={allData}
      filters={filters}
      onFilterChange={onFilterChange}
      selectedRows={selectedRows}
      onSelectRow={handleRowSelect}
      onEyeClick={onEyeClick}
      onDeleteClick={onDeleteClick}
    />

    {allData && allData.length > 0 && (
      <TablePaginators
        paginationIndex={paginationIndex}
        setPaginationIndex={setPaginationIndex}
        dataLength={dataLength}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onActionSelected={onActionSelected}
        isViewingArchived={viewArchived}
      />
    )}
  </>
);
}

export default TransactionList;
